import React from 'react'
import Image from 'next/image'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'
import { Icon } from '@wartek-id/icon'

import { Anchor } from 'components/Anchor'
import { GATrackEvent } from 'utils/googleAnalytics'

interface Props {
  id: string
  title: string
  figureImageUrl: string
  topicsLength: number
  isActive?: boolean
}

const LearningSeriesCard = ({
  id,
  title,
  figureImageUrl,
  topicsLength,
  isActive = false,
}: Props) => {
  const href = `/${
    process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || 'pelatihan-mandiri'
  }/seri-pelatihan/${id}`

  return (
    <Anchor href={href}>
      <a
        data-testid="learning-series"
        className={clsx(
          `relative border rounded flex cursor-pointer appearance-none`,
          isActive ? 'border-primary bg-blue-10' : 'bg-white border-subdued '
        )}
        onClick={() => {
          GATrackEvent({
            eventName: 'learning_activity',
            eventParams: {
              event_trigger: 'choose_series',
              action_type: 'choose_series',
              meta: JSON.stringify({
                series_id: id,
              }),
            },
            sendDefaultParams: true,
          })
        }}
        href={href}
      >
        <div className="flex flex-1 flex-col pl-3 py-3">
          <div className="flex-1 line-clamp-3">
            <Text variant="heading-sm">{title}</Text>
          </div>
          <div className="flex items-center">
            <Icon fontSize="small">topic</Icon>
            <div className="ml-3">
              <Text variant="helper-bold" data-testid="topic-length">
                {topicsLength} Topik
              </Text>
            </div>
          </div>
        </div>
        <div className="flex ml-3">
          <Image
            src={figureImageUrl}
            alt="Figure Illustration"
            width={94}
            height={112}
            unoptimized
          />
        </div>
      </a>
    </Anchor>
  )
}

export default LearningSeriesCard
